import { updateAgent } from '@/services/api';
import { useAgentEditorStore } from '@/state/root';
import { ExtendedLocation } from '@/utils/types';
import { LLM } from '@d-id/types';
import { useMutation } from 'react-query';
import { useLocation } from 'react-router-dom';

export const useRevertAgent = () => {
    const agentEditorStore = useAgentEditorStore();
    const locationState = useLocation() as ExtendedLocation;

    return useMutation('revert-agent', () => {
        const { wasEmbedded } = locationState.state || {};
        const { inputAgent } = agentEditorStore;

        const { id, status, created_at, modified_at, chats, embed, owner_id, score, ...rest } = inputAgent;

        let llm = rest.llm as Partial<LLM> | undefined;

        return updateAgent({ agentId: inputAgent.id, update: { ...rest, embed: wasEmbedded, llm } });
    });
};
